import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionHref?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  actionHref,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-3xl text-secondary-700">
        <i className={icon}></i>
      </span>
      <h3 className="mt-4 text-base font-semibold text-foreground-900">{title}</h3>
      {description ? (
        <p className="mt-2 max-w-md text-sm text-foreground-500">{description}</p>
      ) : null}
      {actionLabel && actionHref ? (
        <Link
          to={actionHref}
          className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </Link>
      ) : null}
      {actionLabel && onAction && !actionHref ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}